if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.previousButton = this.querySelector('[data-product-modal-prev]');
        this.nextButton = this.querySelector('[data-product-modal-next]');
        this.content = this.querySelector('.product-media-modal__content');
        this.mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));
        this.touchStartX = 0;
        this.touchStartY = 0;

        [this.previousButton, this.nextButton].forEach((button) => {
          if (!button) return;
          button.addEventListener('pointerup', (event) => event.stopPropagation());
        });

        this.previousButton?.addEventListener('click', (event) => {
          event.preventDefault();
          this.showAdjacentMedia(-1);
        });

        this.nextButton?.addEventListener('click', (event) => {
          event.preventDefault();
          this.showAdjacentMedia(1);
        });

        this.addEventListener('keyup', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.code.toUpperCase() === 'ARROWLEFT') this.showAdjacentMedia(-1);
          if (event.code.toUpperCase() === 'ARROWRIGHT') this.showAdjacentMedia(1);
        });

        this.content?.addEventListener(
          'touchstart',
          (event) => {
            const touch = event.changedTouches[0];
            this.touchStartX = touch.clientX;
            this.touchStartY = touch.clientY;
          },
          { passive: true }
        );

        this.content?.addEventListener(
          'touchend',
          (event) => {
            const touch = event.changedTouches[0];
            const deltaX = touch.clientX - this.touchStartX;
            const deltaY = touch.clientY - this.touchStartY;

            if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
            this.showAdjacentMedia(deltaX < 0 ? 1 : -1);
          },
          { passive: true }
        );
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        this.loadActiveMedia(activeMedia, activeMediaContent);
        this.updateNavigationState();
      }

      showAdjacentMedia(direction) {
        if (!this.mediaItems.length) return;

        const activeMedia = this.querySelector('[data-media-id].active');
        const currentIndex = Math.max(0, this.mediaItems.indexOf(activeMedia));
        const nextIndex = (currentIndex + direction + this.mediaItems.length) % this.mediaItems.length;
        const nextMedia = this.mediaItems[nextIndex];

        if (!nextMedia) return;

        window.pauseAllMedia();
        this.mediaItems.forEach((element) => element.classList.remove('active'));
        nextMedia.classList.add('active');
        nextMedia.focus?.({ preventScroll: true });

        const template = nextMedia.querySelector('template');
        const templateContent = template ? template.content : null;
        this.loadActiveMedia(nextMedia, templateContent);
        this.updateNavigationState();
      }

      loadActiveMedia(activeMedia, activeMediaContent) {
        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      updateNavigationState() {
        const shouldShowNavigation = this.mediaItems.length > 1;
        [this.previousButton, this.nextButton].forEach((button) => {
          if (!button) return;
          button.hidden = !shouldShowNavigation;
        });
      }
    }
  );
}
